var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar"},[_c('header-home',{attrs:{"back":"#f8f8f8","color":"#000000"}}),_c('div',{staticClass:"my-margin"},[(_vm.schedules != null)?_c('schedule',{attrs:{"schedules":_vm.schedules},on:{"scheduleTap":_vm.scheduleTap,"chooseDate":_vm.chooseDate,"selectDate":_vm.selectDate}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }